import React, { createContext, useContext, useCallback, useState } from 'react';

/**
 * Preferenze tastiera a comparsa, salvate PER DISPOSITIVO (localStorage):
 *  - abilitazione della tastiera grande sui campi di testo (non numerici)
 *  - layout selezionato (QWERTY / QWERTZ / AZERTY / QZERTY)
 * La configurazione è modificabile solo dall'Admin (gestita nelle Impostazioni),
 * ma vale per il dispositivo e quindi per i profili Admin/Manager/Cassa.
 */
const Ctx = createContext(null);

const LS_ENABLED = 'vexel_vk_enabled';
const LS_LAYOUT = 'vexel_vk_layout';

export const KEYBOARD_LAYOUTS = ['qwerty', 'qwertz', 'azerty', 'qzerty'];
// Ruoli per cui la tastiera a comparsa è attiva.
export const KEYBOARD_ROLES = ['admin', 'manager', 'cashier'];

const readEnabled = () => {
  try { return localStorage.getItem(LS_ENABLED) === '1'; } catch { return false; }
};
const readLayout = () => {
  try {
    const v = localStorage.getItem(LS_LAYOUT);
    return KEYBOARD_LAYOUTS.includes(v) ? v : 'qwerty';
  } catch { return 'qwerty'; }
};

export const KeyboardProvider = ({ children }) => {
  const [enabled, setEnabledState] = useState(readEnabled);
  const [layout, setLayoutState] = useState(readLayout);

  const setEnabled = useCallback((v) => {
    setEnabledState(!!v);
    try { localStorage.setItem(LS_ENABLED, v ? '1' : '0'); } catch { /* noop */ }
  }, []);

  const setLayout = useCallback((v) => {
    const val = KEYBOARD_LAYOUTS.includes(v) ? v : 'qwerty';
    setLayoutState(val);
    try { localStorage.setItem(LS_LAYOUT, val); } catch { /* noop */ }
  }, []);

  return (
    <Ctx.Provider value={{ enabled, layout, setEnabled, setLayout }}>
      {children}
    </Ctx.Provider>
  );
};

export const useKeyboard = () => {
  const ctx = useContext(Ctx);
  if (!ctx) throw new Error('useKeyboard deve essere usato dentro KeyboardProvider');
  return ctx;
};
